export default __webpack_public_path__ + "assets/img/Cat_snaps_2.jpg";